/// <reference types="aws-sdk" />

import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import 'swiper/dist/css/swiper.min.css' // Ensure you are using css-loader

// import 'swiper/dist/js/swiper.min.js' // Ensure you are using css-loader

import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import Ads from 'vue-google-adsense'


// import entire SDK
//import AWS from 'aws-sdk');
// import AWS object without services
//import AWS from 'aws-sdk/global'
// import individual service
//import S3 from 'aws-sdk/clients/s3'

import vUploader from 'v-uploader'

// v-uploader plugin global config
const uploaderConfig = {
    // file uploader service url
    uploadFileUrl: '//cardolini.ru/includes/imgsave.php',
    // file delete service url
    deleteFileUrl: '//cardolini.ru/includes/image_delete.php',
    language: 'en',
    // set the way to show upload message(upload fail message)
    showMessage: (vue, message) => {
        //using v-dialogs to show message
        alert(message)
            // vue.$vDialog.alert(message, null, {messageType: 'error'});
    }
}

// install plugin with options
Vue.use(vUploader, uploaderConfig)
Vue.config.productionTip = false

Vue.use(require('vue-script2'))

Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')